module.exports = __webpack_public_path__ + "static/media/20ECE15.fbd0cbe1.jpg";